export const ELEMENT_CLASS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const FILTER_STRINGS = {
  ALL: 'all',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

export const DAYS_OF_WEEK = {
  HR: ['NED', 'PON', 'UTO', 'SRI', 'ČET', 'PET', 'SUB'],
  EN: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
};

export const ACTION_ID = {
  NORMAL: 49,
  FREE_TICKET: 3,
  EXCLUSIVE_SUBSCRIBER_TICKET: 153,
  SUBSCRIBER_TICKET: 50,
  SUBSCRIBER_TICKET_OS: 53,
};

export const membershipTypes = {
  FULL_FLEDGED: 'CLAN',
  CLUB_FRIEND: 'CLAN_PRIJATELJ',
};

export const allowedOrigins = new Set<string>([
  'https://form.wspay.biz',
  'https://formtest.wspay.biz'
]);
